<script lang="ts">
    import {getInjector, getLocalization} from 'core/svelte-context/context';
    import {createSpecialSymbolsKeyboardAction} from 'shared/value-editors/internal/shared/use.special-symbols-keyboard';
    import {exists} from 'shared/utils/custom-utils';
    import ModalConversationService from '../../../../../modals/modal-conversation.service';
    import KpContextMenuWrapper from 'shared/components/kp-context-menu/KpContextMenuWrapper.svelte';
    import KpContextMenuButton from 'shared/components/kp-context-menu/KpContextMenuButton.svelte';
    import KpContextMenuTextualActions from 'shared/components/kp-context-menu/KpContextMenuTextualActions.svelte';
    import KpHorizontalSeparator from 'shared/ui-widgets/separator/KpHorizontalSeparator.svelte';

    export let inputElement: HTMLInputElement | HTMLTextAreaElement;
    export let editorId: string;
    export let disabled = false;

    const modalConversationService = getInjector().tryGetByClass<ModalConversationService>(ModalConversationService);
    const localize = getLocalization();

    const handleSpecialSymbolsClick = () => {
        if (!exists(modalConversationService)) {
            return;
        }

        modalConversationService.specialSymbolsKeyboard({inputRef: inputElement});
    }
</script>

<KpContextMenuWrapper id="{editorId}-context-menu" {disabled}>
    <svelte:fragment slot="context-content">
        <KpContextMenuTextualActions {inputElement}/>
        <KpHorizontalSeparator width="100%"/>

        <KpContextMenuButton on:click={handleSpecialSymbolsClick}>
            {localize(/* @kp-localization commons.InsertingSpecialCharactersButtonLabel */ 'commons.InsertingSpecialCharactersButtonLabel')}
        </KpContextMenuButton>
    </svelte:fragment>

    <slot specialSymbolsKeyboardAction="{createSpecialSymbolsKeyboardAction(modalConversationService)}"/>
</KpContextMenuWrapper>